var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live-item"},[_c(_vm.realData.component,{tag:"component",attrs:{"data":_vm.realData.data,"baseData":_vm.itemData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }